(function () {

    'use strict';

    angular.module('filter')
        .controller('FilterController', [
            '$scope',
            'FilterService',
            'DataService',
            function ($scope, FilterService, DataService) {
                $scope.isOpen = false;
                $scope.dataService = DataService;
                $scope.filter = {
                    parameter: '',
                    operand: null,
                    operation: 'AND',
                    value: '',
                    type: ''
                };

                if (FilterService.filters.length === 0) {
                    FilterService.filters.push(angular.copy($scope.filter));
                }

                $scope.toggleDropdown = function(filter) {
                    filter.isMultiselectOpen = !filter.isMultiselectOpen;
                };

                $scope.isInValueSelected = function(filter, item) {
                    if (filter.operand === 'IN' && filter.valuesArray && filter.valuesArray.length > 0) {
                        for (var j = 0; j < filter.valuesArray.length; j++) {
                            var value = filter.valuesArray[j];
                            if (value === item.name) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                $scope.toggleSelection = function(filter, item) {
                    if (!filter.valuesArray) {
                        filter.valuesArray = [];
                    }

                    var found = false;
                    angular.forEach(filter.valuesArray, function(value, index) {
                        if (value === item.name) {
                            filter.valuesArray.splice(index, 1);
                            found = true;
                        }
                    });

                    if (!found) {
                        filter.valuesArray.push(item.name);
                    }
                }

                $scope.addFilter = function () {
                    FilterService.currentFilters.push(angular.copy($scope.filter));
                };

                $scope.doFilter = function () {
                    if (FilterService.currentFilters.length > 0) {
                        var withErrors = false;
                        angular.forEach(FilterService.currentFilters, function (filter) {
                            if (!filter.parameter || !filter.operand || (!filter.value && filter.operand !== 'IN') || ((!filter.valuesArray || filter.valuesArray.length === 0) && filter.operand === 'IN')) {
                                withErrors = true;
                            }
                        });
                        if (withErrors) {
                            alert('Filtrui(-ams) nenurodytas (-ti) parametras (-ai) arba operandas (-ai)');
                            return;
                        }
                        FilterService.currentFilters[0].operation = 'AND';
                    }
                    $scope.dataService.refreshData(FilterService.currentFilters);
                    FilterService.filters = FilterService.currentFilters;
                };

                var multiselectClickOutsideHandler = function(event) {
                    if (!event.target.closest('.custom-multiselect')) {
                        angular.forEach(FilterService.currentFilters, function(item) {
                            if (item.isMultiselectOpen) {
                                item.isMultiselectOpen = false;
                                $scope.$apply();
                            }
                        });
                        $scope.$apply();
                    }
                }

                document.addEventListener('click', multiselectClickOutsideHandler);

                $scope.$on('$destroy', function() {
                    if (multiselectClickOutsideHandler) {
                        document.removeEventListener('click', multiselectClickOutsideHandler);
                    }
                });
            }]);
})();
